const PageButtons = ({ page, setPage, total_pages }) => {
  return (
    <section className="page-buttons__box">
      <button
        className={`page-buttons__buttons ${
          page === 1 ? "button--disabled" : ""
        }`}
        disabled={page === 1}
        onClick={() => {
          setPage((page) => page - 1);
        }}
      >
        &laquo;
      </button>{" "}
      Page {page} of {total_pages}{" "}
      <button
        className={`page-buttons__buttons ${
          page === total_pages ? "button--disabled" : ""
        }`}
        disabled={page === total_pages}
        onClick={() => {
          setPage((page) => page + 1);
        }}
      >
        &raquo;
      </button>
    </section>
  );
};

export default PageButtons;
